import apiClient from './apiClient';

const authApi = {
  getMe() {
    return apiClient.get('/api/me');
  },

  /**
   * Step 1 of email login: request a passcode be emailed to the address.
   * Always resolves ok (server does not reveal whether an account exists).
   */
  requestCode(email) {
    return apiClient.post('/api/login/request-code', { email });
  },

  /**
   * Step 2 of email login: verify the passcode and establish the session.
   * Rejects (400) on an invalid/expired code.
   */
  verifyCode(email, code) {
    return apiClient.post('/api/login/verify-code', { email, code });
  }
};

export default authApi;
